import { useEffect, useState } from 'react';
import {
    Container,
    Box,
    // Checkbox,
    Typography,
    Button,
    TextField
} from '@mui/material';

import {
    // GridFooter,
    DataGrid,
    // GridToolbarContainer,
    // GridFooterContainer,
} from '@mui/x-data-grid';

// import Header from '../../components/Header';
import { callApi } from '../../utils/request';

import Alert from '../../components/Alert';

export default function ListVariables() {
    const [alert, setAlert] = useState(null);
    const [variablesFixed, setVariablesFixed] = useState([]);
    // const [modifiedVariable, setModifiedVariable] = useState(null);

    useEffect(() => {
        callApi('/operateur/variablesFixed', 'GET').then((res) => {
            setVariablesFixed(res);
        }).catch((error) => {
            console.error('Error fetching variables:', error);
            setAlert({ variant: 'error', message: 'Erreur lors du chargement des variables.' });
        });
    }, []);

    // handleSave met à jour les variables fixes modifiées.
    const handleSave = () => {
        // Validation des données avant l'envoi : on vérifie que toutes
        // les valeurs sont des nombres strictement positifs.
        variablesFixed.forEach(variable => {
            let value = variable.value;

            // Si la valeur est une chaîne de caractères, on tente de la convertir en nombre.
            if ("string" === typeof value) {
                const tmp = Number(value.replace(/,/g, '.'));
                if (!isNaN(tmp)) {
                    value = tmp;

                    // Mise à jour de la variable dans le state
                    // pour refléter la valeur numérique.
                    handleValueChange(variable.name, value);
                } else {
                    return setAlert({ variant: 'error', message: `La valeur de la variable ${variable.name} doit être un nombre.` });
                }
            } else if ("number" !== typeof value) {
                return setAlert({ variant: 'error', message: `La valeur de la variable ${variable.name} doit être un nombre.` });
            }

            // Validation de la valeur : elle doit être strictement positive.
            if (value <= 0) {
                return setAlert({ variant: 'error', message: `La valeur de la variable ${variable.name} doit être supérieure à zéro.` });
            }
        });

        // Envoi de la requête de mise à jour au backend.
        callApi(`/admin/updateVariable`, 'POST', variablesFixed)
        .then((res) => {
            if (res.alert) {
                setAlert(res.alert);

                // Si la mise à jour est réussie, on efface l'alerte après 3 secondes.
                if (res.alert.variant === 'success') setTimeout(() => setAlert(null), 3000);
            }
        });

        // setModifiedVariable(null);
    };

    // handleValueChange et handleCheckboxChange permettent de mettre
    // à jour la variable fixed correspondante dans le state à chaque
    // modification d'un champ du tableau.
    // Cela permet d'avoir toujours la dernière valeur modifiée en mémoire,
    // prête à être envoyée au backend lors de la sauvegarde.
    // 
    // TODO : refactorer pour n'avoir qu'une seule fonction de gestion des changements, plus générique, qui puisse gérer à la fois les TextField et les Checkbox.
    const handleValueChange = (id, newValue) => {
        setVariablesFixed((variables) =>
            variables.map((variable) =>
                variable.name === id ? { ...variable, value: newValue } : variable
            )
        );

        // setModifiedVariable(id);
    };

    // const handleCheckboxChange = (event, id) => {
    //     const { name, checked } = event.target;
    //     setVariablesFixed((variables) =>
    //         variables.map((variable) =>
    //             variable.name === id ? { ...variable, [name]: checked } : variable
    //         )
    //     );
    //     setModifiedVariable(id);
    // };

    const columns = [
        { field: 'name', headerName: 'Nom', width: 250 },
        {
            field: 'value', headerName: 'Valeur', width: 200, renderCell: params =>
                <TextField
                    size='small'
                    variant="standard"
                    sx={{ verticalAlign: 'middle', fontSize:'small', border:'none' }}
                    inputProps={{ style: { fontSize:'small', border:'none' } }}
                    value={params.value}
                    onChange={(event) => handleValueChange(params.id, event.target.value)}
                />
        },
        // {
        //     field: 'anoView', headerName: 'Vue Anonyme', width: 135, renderCell: (params) => (
        //         // WARNING : désactivé car le process de sauvegarde ne fonctionne pas.
        //         <></>
        //         // <Checkbox
        //         //     checked={params.row.anoView}
        //         //     size='small'
        //         //     onChange={(event) => handleCheckboxChange(event, params.row.id)}
        //         // />
        //     ),
        // },
        // {
        //     field: 'anoEdit', headerName: 'Edit Anonyme', width: 135, renderCell: (params) => (
        //         // WARNING : désactivé car le process de sauvegarde ne fonctionne pas.
        //         <></>
        //         // <Checkbox
        //         //     checked={params.row.anoEdit}
        //         //     size='small'
        //         //     onChange={(event) => handleCheckboxChange(event, params.row.id)}
        //         // />
        //     ),
        // },
        // {
        //     field: 'opeView', headerName: 'Vue Opérateur', width: 135, renderCell: (params) => (
        //         // WARNING : désactivé car le process de sauvegarde ne fonctionne pas.
        //         <></>
        //         // <Checkbox
        //         //     checked={params.row.opeView}
        //         //     size='small'
        //         //     onChange={(event) => handleCheckboxChange(event, params.row.id)}
        //         // />
        //     ),
        // },
        // {
        //     field: 'opeEdit', headerName: 'Edit Opérateur', width: 135, renderCell: (params) => (
        //         // WARNING : désactivé car le process de sauvegarde ne fonctionne pas.
        //         <></>
        //         // <Checkbox
        //         //     checked={params.row.opeEdit}
        //         //     size='small'
        //         //     onChange={(event) => handleCheckboxChange(event, params.row.id)}
        //         // />
        //     ),
        // },
        {
            field: 'save',
            headerName: 'Action',
            width: 150,
            renderCell: (params) => {
                // const isModified = params.id === modifiedVariable;
                return /*isModified ||*/ true && (
                    <Button
                        size="small"
                        sx={{fontSize:'smaller'}}
                        onClick={handleSave}
                        children="Sauvegarder"
                    />
                );
            },
        },

    ];

    return (
        <>
        {/* Affichage des alertes */}
        {alert && <Alert alert={alert}/>}

        <Container sx={{ padding: 5 }}>
            {/* Titre de la page */}
            <Typography variant="h4" align='center' children="Liste des variables" />

            {/* Tableau des variables fixes */}
            <Box sx={{ width: '100%' }}>
                {/* <Typography
                    variant="body1"
                    align='center'
                    color='warning'
                    sx={{ mb: 2, mt:-2, fontSize: 'small' }}
                >
                    En raison de problèmes techniques, la modification
                    <br />
                    des variables fixes est actuellement désactivée.
                </Typography> */}

                <DataGrid
                    density="compact"
                    rows={variablesFixed}
                    columns={columns}
                    getRowId={(row) => row.name}
                    disableColumnMenu
                    disableRowSelectionOnClick
                    disableColumnResize
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 10,
                            },
                        },
                    }}
                    pageSizeOptions={[10]}
                    sx={{ backgroundColor: 'white' }}
                />
            </Box>
        </Container>
        </>
    );
}
